import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26, LAST_REVIEWED } from "@/lib/official-sources";

const faqs = [
  { q: "Kan en bar få serveringstillstånd utan kök?", a: "Ja. Från 1 juni 2026 är kraven på eget kök och varierat utbud av lagad mat borttagna. Matservering är inte längre ett villkor för att få serveringstillstånd. Baren behöver alltså inte längre visa kök, meny eller matleverantör vid prövningen." },
  { q: "Vad gäller för sena serveringstider?", a: "Servering efter kl 01:00 prövas särskilt av kommunen och kräver i regel ordningsvakter och bra rutiner för nykterhet och ordning." },
  { q: "Krävs kunskapsprov?", a: "Ja, samma kunskapsprov i alkohollagen gäller för bar och nattklubb." },
];

export const Route = createFileRoute("/serveringstillstand-bar")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "För bar" },
      ]}
      title="Serveringstillstånd för bar"
      intro="Driva bar eller nattklubb? Här är kraven på lokal, mat, serveringstider, ordning och kunskapsprov för serveringstillstånd – uppdaterat för de nya reglerna 2026."
      lastReviewed={LAST_REVIEWED}
      sources={[SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26]}
      sections={[
        { h2: "Nya regler från 1 juni 2026", body: "Riksdagen har slopat kraven på eget kök och varierat utbud av lagad mat. Det innebär att cocktailbarer, vinbarer och ölbarer som tidigare fick avslag på köksparagrafen nu kan kvalificera sig – så länge baren kan erbjuda någon form av mat under serveringstiden." },
        { h2: "Serveringstider", body: "Normal serveringstid är 11:00–01:00. Utökad tid till 02:00 eller 03:00 kräver särskild prövning – kommunen tittar på risk för störningar, lokal och ordningsplan." },
        { h2: "Ordning och nykterhet", body: "Ordningsvakter, dörrkontroll, rutiner mot överservering och åldersgräns 18 år är centrala krav. Anmärkningar kan ge varning eller återkallat tillstånd." },
        { h2: "Kunskapsprovet", body: "PBI måste klara kommunens kunskapsprov. Förbered er noga med Alkoholprovet – 800 frågor och provsimulering." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/nya-regler-serveringstillstand-2026", label: "Nya regler 2026" },
          { to: "/serveringstillstand-restaurang", label: "För restaurang" },
          { to: "/serveringstillstand-cafe", label: "För café" },
          { to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/serveringstillstand-goteborg", label: "Serveringstillstånd Göteborg" },
          { to: "/serveringstillstand-malmo", label: "Serveringstillstånd Malmö" },
          { to: "/alkohollagen-kapitel-8", label: "Alkohollagen kapitel 8" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Serveringstillstånd bar 2026: krav, kostnad & serveringstider" },
      { name: "description", content: "Så får du serveringstillstånd för bar eller nattklubb 2026: matkravet slopas, serveringstider, avgifter och kunskapsprovet – checklista steg för steg." },
      { property: "og:title", content: "Serveringstillstånd för bar" },
      { property: "og:description", content: "Krav, serveringstider och kunskapsprov för bar." },
      { property: "og:url", content: "https://alkoholprovet.se/serveringstillstand-bar" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/serveringstillstand-bar" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "För bar", url: "https://alkoholprovet.se/serveringstillstand-bar" },
      ]),
    ],
  }),
});
